import { render, staticRenderFns } from "./ModalFooter.vue?vue&type=template&id=6b724a2b&scoped=true"
import script from "./ModalFooter.vue?vue&type=script&lang=js"
export * from "./ModalFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b724a2b",
  null
  
)

export default component.exports